import { Box, Stack, Typography } from '@mui/material';
import { ImageExercise } from '../../../student/mockLessonContent';
import { BLUE, cardSx, INTER, NAVY, POPPINS, SLATE, SURFACE_SOFT } from '../../../student/studentStyles';
import AudioPlayButton from '../../../student/components/AudioPlayButton';
import ExerciseLabel from '../../../student/components/exercises/ExerciseLabel';
import { useExerciseLayout } from './exerciseLayout';

// "Dialog w/ Image" — a picture and a teacher line to set the scene, or a plain
// "Dialog Only" line when there is no picture. Nothing to answer, so the player
// lets the student continue straight away.
export default function ImageExerciseCard({ exercise }: { exercise: ImageExercise }) {
    const desktop = useExerciseLayout() === 'desktop';

    return (
        <Box>
            <ExerciseLabel>{exercise.emoji ? 'LOOK' : 'FROM YOUR TEACHER'}</ExerciseLabel>
            <Box sx={{ ...cardSx, overflow: 'hidden' }}>
                {exercise.emoji && (
                    <Box sx={{
                        height: desktop ? 220 : 190, backgroundColor: SURFACE_SOFT,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                        <Typography sx={{ fontSize: 88, lineHeight: 1 }}>{exercise.emoji}</Typography>
                    </Box>
                )}
                <Box sx={{ p: desktop ? 3 : 2.5 }}>
                    <Typography sx={{ fontFamily: INTER, fontSize: 15, color: SLATE, lineHeight: 1.5 }}>
                        {exercise.caption}
                    </Typography>
                    {exercise.chineseHanzi && (
                        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mt: 2 }}>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography sx={{ fontFamily: POPPINS, fontWeight: 600, fontSize: 20, color: NAVY, lineHeight: 1.4 }}>
                                    {exercise.chineseHanzi}
                                </Typography>
                                <Typography sx={{ fontFamily: INTER, fontSize: 13, color: BLUE, mt: 0.25 }}>
                                    {exercise.chinesePinyin}
                                </Typography>
                            </Box>
                            <AudioPlayButton ariaLabel="Play teacher audio" size={40} />
                        </Stack>
                    )}
                </Box>
            </Box>
        </Box>
    );
}
